module.exports = __webpack_public_path__ + "img/34.18379eac.jpeg";